import { render } from "./Embalagem.vue?vue&type=template&id=ad132318"
const script = {}

import "./Embalagem.vue?vue&type=style&index=0&id=ad132318&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\andremudancasemgeral\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__